<script setup lang="ts">
import { useRoute, router } from '@hfc/ui-core';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { UUID } from '@hfc/common';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import ChallengeQuestions from '@/shared/infrastructure/components/ChallengeQuestions.vue';
import { NavigationFailure } from 'vue-router';

const route = useRoute();

const uuid = route.params.uuid as UUID;

const pushRedirect = (): Promise<NavigationFailure | void | undefined> => {
  return router.push({ name: 'CCAccessCode', params: { uuid } });
};

</script>
<template>
  <div class="py-10 space-y-10">
    <div>
      <h1 class="text-center">Verify Your Identity</h1>
    </div>
    <div>
      <ChallengeQuestions :application-type="APPLICATION_TYPES.HEALTH" :local-config="false" :challenge-type="ChallengeType.APPLICATION" :uuid="uuid" :otp-flow="true" @challenge-success="pushRedirect" />
    </div>
  </div>
</template>
